import { useLocation, useNavigate } from "react-router-dom";

import { Alert, Row, Col, Card, Button } from "react-bootstrap";

import "./HomePage.css";

import Footer from "../../Components/common/Footer";

import Header from "../../Components/common/Header";

import DynamicAnnouncement from "../../Components/common/DynamicAnnouncement";

import SocialMadia from "../../Components/common/SocialMadia";

import HeroSection from "../../layout/HeroSection";

import EducationLevelSection from "../../layout/EducationLevelSection";



import { useEffect, useState } from "react";

import { resolveMediaUrl } from "../../utils/mediaUrl";

import { getCoursePackageTypeLabel } from "../../utils/packageLabels";

import axios from "axios";

import { baseURL } from "../../API/API";

import ImgFirst from "../../Imge/first_sec_bio.png";

import ImgSecond from "../../Imge/second_sec_bio.png";

import ImgThird from "../../Imge/third_sec_bio.png";

import FallbackImg from "../../Imge/about_2.png";

import TeacherImage from "../../Imge/about_2.png";
import LogoNohe from "../../Imge/LogoNohe.png";

import L1Img from "../../Imge/l1.png";

import L2Img from "../../Imge/l2.png";

import { FaRegCalendarAlt, FaRegClock, FaStar, FaGraduationCap } from "react-icons/fa";

import useAuth from "../hooks/useAuth";

import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";



// Swiper imports

import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";

import "swiper/css/navigation";

import "swiper/css/pagination";



const getCourseBadge = (name) => {

  if (!name) return null;

  const lowerName = name.toLowerCase();

  if (lowerName.includes("أزهر") || lowerName.includes("ازهر")) {

    return { text: "أزهري", type: "azhar" };

  }

  if (lowerName.includes("عام") || lowerName.includes("العام")) {

    return { text: "ثانوي عام", type: "general" };

  }

  if (lowerName.includes("معسكر") || lowerName.includes("انقاذ") || lowerName.includes("أنقاذ")) {

    return { text: "خصم مميز", type: "discount" };

  }

  if (lowerName.includes("مراجعة") || lowerName.includes("مراجعه") || lowerName.includes("نهائية") || lowerName.includes("نهائيه")) {

    return { text: "مراجعة نهائية", type: "revision" };

  }

  return null;

};



const getChapterImage = (name) => {

  if (!name) return FallbackImg;

  const lowerName = name.toLowerCase();

  if (lowerName.includes("معسكر النحو الشامل") && (lowerName.includes("عام") || lowerName.includes("العام"))) {

    return L1Img;

  }

  if (lowerName.includes("معسكر النحو الشامل") && (lowerName.includes("أزهر") || lowerName.includes("ازهر"))) {

    return L2Img;

  }

  if (lowerName.includes("أزهر") || lowerName.includes("ازهر")) {

    return ImgThird;

  }

  if (lowerName.includes("معسكر") || lowerName.includes("انقاذ") || lowerName.includes("أنقاذ")) {

    return ImgFirst;

  }

  if (lowerName.includes("مراجعة") || lowerName.includes("مراجعه") || lowerName.includes("نهائية") || lowerName.includes("نهائيه")) {

    return ImgSecond;

  }

  return FallbackImg;

};



const getChapterDescription = (name) => {
  return "شرح وتأسيس متكامل للمناهج الدراسية لطلاب الثانوية العامة والأزهرية، بأسلوب يجمع بين التبسيط والعمق الأكاديمي لضمان تحقيق الدرجة النهائية والتفوق الدراسي.";
};
const _old_getChapterDescription = (name) => {

  if (!name) return "شرح تفصيلي متكامل لمنهج اللغة العربية مع تدريبات تفاعلية مستمرة لضمان تحقيق الدرجة النهائية.";

  const lowerName = name.toLowerCase();

  if (lowerName.includes("أزهر") || lowerName.includes("ازهر")) {

    return "شرح شامل ومفصل لمنهج اللغة العربية لطلاب الثانوية الأزهرية (النحو، الصرف، البلاغة، الأدب والنصوص) مع امتحانات دورية قوية.";

  }

  if (lowerName.includes("عام") || lowerName.includes("العام")) {

    return "كورس اللغة العربية المتكامل لطلاب الثانوية العامة، شرح وتأسيس متكامل لكافة الفروع مع تطبيقات معادلات الهندسة النحوية المتميزة.";

  }

  if (lowerName.includes("معسكر") || lowerName.includes("انقاذ") || lowerName.includes("أنقاذ")) {

    return "معسكر الإنقاذ السريع! لمّ منهج النحو والبلاغة بالكامل في أسبوع واحد فقط بأسلوب الهندسة النحوية المبتكر وبسعر مميز.";

  }

  if (lowerName.includes("مراجعة") || lowerName.includes("مراجعه") || lowerName.includes("نهائية") || lowerName.includes("نهائيه")) {

    return "المراجعة النهائية الشاملة في اللغة العربية لكافة الفروع، مع أقوى بنك أسئلة ونماذج امتحانات تفاعلية تحاكي الامتحان النهائي.";

  }

  return "شرح تفصيلي متكامل لمنهج اللغة العربية مع تدريبات تفاعلية مستمرة لضمان تحقيق الدرجة النهائية.";

};



const getChapterDates = (name) => {

  if (!name) return { startDate: "الاثنين، 6 أبريل", startTime: "02:00 م" };

  const lowerName = name.toLowerCase();

  if (lowerName.includes("معسكر") || lowerName.includes("انقاذ") || lowerName.includes("أنقاذ")) {

    return { startDate: "الخميس، 12 يناير", startTime: "05:00 م" };

  }

  return { startDate: "الاثنين، 6 أبريل", startTime: "02:00 م" };

};



const processCourses = (data) => {

  return data.map((course) => {

    const name = course.name || "";

    let price = 150;

    let description = getChapterDescription(name);



    if (name.includes("معسكر النحو الشامل") && (name.includes("عام") || name.includes("العام"))) {

      price = 250;

      description = "معسكر النحو الشامل لطلاب الثانوية العامة - شرح كامل وتدريبات مكثفة على جميع قواعد النحو والاعراب.";

    } else if (name.includes("معسكر النحو الشامل") && (name.includes("أزهر") || name.includes("ازهر"))) {

      price = 250;

      description = "معسكر النحو الشامل لطلاب الثانوية الأزهرية - شرح كامل وتدريبات مكثفة متوافقة مع منهج الأزهر الشريف.";

    } else if (name.includes("الأول") || name.includes("اول")) {

      price = 125;

    } else if (name.includes("الثاني") || name.includes("تانى") || name.includes("ثانى")) {

      price = 150;

    } else if (name.includes("الثالث") || name.includes("تالت")) {

      price = 200;

    }



    const dates = getChapterDates(course.name);

    return {

      ...course,

      academic_year_id: course.academic_year_id || course.id,
      teacher_id: course.teacher_id || "admin",
      teacher_name: course.teacher?.name || course.teacher_name || "أ / محمود الصبروط",
      is_admin_teacher: !course.teacher_id,
      price: course.price || price,

      image: resolveMediaUrl(course.image_path) || course.image || getChapterImage(course.name),

      description: course.description || description,

      startDate: course.startDate || dates.startDate,

      startTime: course.startTime || dates.startTime,

    };

  });

};



const fallbackCourses = [
  {
    id: "fallback-admin-arabic-1",
    name: "معسكر النحو الشامل - الصف الأول الثانوي (العام)",
    academic_year_id: 1,
    teacher_id: "admin",
    teacher_name: "أ / محمود الصبروط",
    price: 150,
    discount: 0,
    image: L1Img,
    description: "شرح مركز لقواعد النحو في مكان واحد مع تدريبات عملية ونماذج امتحانات.",
    startDate: "الاثنين، 6 أبريل",
    startTime: "02:00 م",
  },
  {
    id: "fallback-admin-arabic-2",
    name: "المراجعة النهائية في اللغة العربية - الصف الثاني الثانوي",
    academic_year_id: 2,
    teacher_id: "admin",
    teacher_name: "أ / محمود الصبروط",
    price: 150,
    discount: 0,
    image: ImgSecond,
    description: "مراجعة شاملة على أهم فروع اللغة العربية مع أسئلة تفاعلية قبل الامتحان.",
    startDate: "الخميس، 12 يناير",
    startTime: "05:00 م",
  },
  {
    id: "fallback-admin-arabic-3",
    name: "معسكر النحو الشامل - الصف الثالث الثانوي (الأزهري)",
    academic_year_id: 3,
    teacher_id: "admin",
    teacher_name: "أ / محمود الصبروط",
    price: 200,
    discount: 0,
    image: L2Img,
    description: "خطة مكثفة لطلاب الأزهر تجمع الشرح والتدريب والمتابعة في كورس واحد.",
    startDate: "الاثنين، 6 أبريل",
    startTime: "02:00 م",
  },
];

const ensureSuggestedCourses = (items) => {
  return processCourses(items);
};

const testimonials = [

  { name: "أحمد محمد", level: "ثالثة ثانوي عام", text: "الهندسة النحوية غيرت طريقتي في حل النحو تماماً، النحو بقى أسهل من الرياضيات بفضل معادلات منصة نوح التعليمية", stars: 5 },

  { name: "فاطمة علي", level: "تانية ثانوي أزهري", text: "منهج البلاغة والصرف كان كابوس بالنسبة لي، بس مع شرح المدرس بقيت أحل الامتحانات وأنا واثقة جداً", stars: 5 },

  { name: "عمر حسن", level: "أولى ثانوي عام", text: "الشرح مبسط وممتع جداً، والمنصة منظمة وبتخليني أحب لغتنا العربية وأفهمها مش بس أحفظ القواعد", stars: 5 },

  { name: "مريم خالد", level: "ثالثة ثانوي أزهري", text: "شعار نُوحٌ نَحوَ نَحوٍ جَدِيدٍ حقيقة ملموسة! قدرت أقفل امتحان العربي التجريبي بفضل المتابعة والتدريبات القوية", stars: 5 },

  { name: "يوسف سامي", level: "تانية ثانوي عام", text: "الامتحانات الدورية وبنك الأسئلة ساعدوني أعرف مستواي وأتحسن أول بأول، شكراً نوح أكاديمي ومساعدين مستر محمود", stars: 5 },

  { name: "نورا إبراهيم", level: "أولى ثانوي أزهري", text: "أفضل منصة لتعليم اللغة العربية بالأزهر، الشرح وافي جداً وبيراعي كل تفاصيل المنهج الأزهري والشرعي", stars: 5 },

  { name: "كريم طارق", level: "ثالثة ثانوي عام", text: "محاضرات ليالي الامتحان والمراجعة المركزة هي اللي أنقذتني، قدرت أراجع فروع العربي كلها في وقت قياسي وبثقة كاملة", stars: 5 },

  { name: "سارة وليد", level: "تانية ثانوي أزهري", text: "متابعة ولي الأمر خلت والدي مبسوط جداً وبيتابع تقارير أدائي ودرجاتي في اختبارات اللغة العربية أسبوعياً", stars: 5 },

  { name: "محمود عادل", level: "أولى ثانوي عام", text: "المعادلات النحوية سهلت علينا القواعد، النحو مبقاش حفظ وتلقين، النحو فهم هندسي ممتاز وممتع مع المدرس", stars: 5 },

  { name: "هنا أحمد", level: "ثالثة ثانوي أزهري", text: "المنصة وتطبيقها ممتازة جداً وسهلة، الشرح عميق وأسلوب المدرس يخليك تحب المادة وتتفوق فيها بسهولة", stars: 5 },

];



export default function HomePage() {

  const location = useLocation();

  const navigate = useNavigate();

  const { auth } = useAuth();

  const unauthorized = location.state?.unauthorized;

  const [courses, setCourses] = useState([]);

  const [combos, setCombos] = useState([]);

  const [coursePackages, setCoursePackages] = useState([]);



  const [teachers, setTeachers] = useState([]);

  const [filteredTeachers, setFilteredTeachers] = useState([]);

  const [academicYears, setAcademicYears] = useState([]);

  const [selectedSubject, setSelectedSubject] = useState("-");

  const [selectedGrade, setSelectedGrade] = useState("-");

    const [showAllTeachers, setShowAllTeachers] = useState(false);



  // Fetch teachers and stages

  useEffect(() => {

    axios.get(`${baseURL}/learning/teachers`, { params: { include_admin: 1 } })

      .then(res => {

        setTeachers(res.data?.data || []);

        setFilteredTeachers(res.data?.data || []);

      })

      .catch(err => console.error("Error fetching teachers:", err));



    axios.get(`${baseURL}/learning/academics`)

      .then(res => {

        setAcademicYears(res.data?.data || []);

      })

      .catch(err => console.error("Error fetching academics:", err));



    axios.get(`${baseURL}/learning/combos/list`)

      .then(res => {

        setCombos(res.data?.data || []);

      })

      .catch(err => console.error("Error fetching combos:", err));



    axios.get(`${baseURL}/learning/packages/list`)

      .then(res => {

        setCoursePackages(res.data?.data || []);

      })

      .catch(err => console.error("Error fetching course packages:", err));

  }, []);



  // Filter teachers dynamically via API

  useEffect(() => {

    const fetchFiltered = async () => {

      try {

        const params = {};

        if (selectedSubject !== "-") params.subject = selectedSubject;

        if (selectedGrade !== "-") params.academic_year_id = selectedGrade;

        

        params.include_admin = 1;
        const res = await axios.get(`${baseURL}/learning/teachers`, { params });

        setFilteredTeachers(res.data?.data || []);

      } catch (err) {

        console.error("Error filtering teachers:", err);

      }

    };

    fetchFiltered();

  }, [selectedSubject, selectedGrade, teachers]);



  const uniqueSubjects = ["-", ...new Set(teachers.map(t => t.subject).filter(Boolean))];



  const getCourseLearnPath = (course) => {
    const stageId = course.academic_year_id || 10;
    const teacherId = course.teacher_id || course.teacherId || (course.is_admin_teacher ? "admin" : null);
    return teacherId ? `/learn/${stageId}?teacher_id=${teacherId}` : `/learn/${stageId}`;
  };

  const handleCourseClick = (course) => {
    const stageId = course.academic_year_id || 10;
    if (!auth?.accessToken) {
      toast.info("\u064a\u0631\u062c\u0649 \u0625\u0646\u0634\u0627\u0621 \u062d\u0633\u0627\u0628 \u0623\u0648 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644 \u0644\u0639\u0631\u0636 \u0645\u062d\u062a\u0648\u0649 \u0627\u0644\u0643\u0648\u0631\u0633");
      navigate("/register", { state: { selectedStageId: stageId } });
      return;
    }
    if (auth.user?.is_staff) {
      navigate(getCourseLearnPath(course));
      return;
    }
    const enrolledId = auth.user?.academic_year_id;
    if (Number(stageId) !== Number(enrolledId)) {
      toast.error("\u0623\u0646\u062a \u0644\u0633\u062a \u0645\u0633\u062c\u0644\u0627 \u0641\u064a \u0647\u0630\u0647 \u0627\u0644\u0645\u0631\u062d\u0644\u0629. \u064a\u0645\u0643\u0646\u0643 \u0641\u0642\u0637 \u0627\u0644\u062f\u062e\u0648\u0644 \u0625\u0644\u0649 \u0645\u0631\u062d\u0644\u062a\u0643 \u0627\u0644\u0645\u0633\u062c\u0644\u0629.");
      return;
    }
    navigate(getCourseLearnPath(course));
  };
  const handleSubscribeClick = (course) => {

    const stageId = course.academic_year_id || 10;

    if (!auth?.accessToken) {

      toast.info("\u064a\u0631\u062c\u0649 \u0625\u0646\u0634\u0627\u0621 \u062d\u0633\u0627\u0628 \u0623\u0648 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644 \u0644\u0639\u0631\u0636 \u0645\u062d\u062a\u0648\u0649 \u0627\u0644\u0643\u0648\u0631\u0633");
      navigate("/register", { state: { selectedStageId: stageId } });

      return;

    }

    navigate(`/invoice/${course.id}`, {

      state: {

        price: Number(course.price ?? 150),

        discount: Number(course.discount ?? 0),

        courseName: course.name,

      },

    });

  };



useEffect(() => {
  async function fetchChapterWithRetry(yearId, retries = 2) {
    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        const res = await axios.get(`${baseURL}/learning/chapters/${yearId}`);
        return res.data?.data || [];
      } catch (err) {
        if (attempt === retries) {
          console.error(`Failed to fetch chapters for year ${yearId} after ${retries + 1} attempts:`, err);
          return []; // fail gracefully for this year only, don't break the rest
        }
        // wait a bit before retrying (500ms, then 1000ms)
        await new Promise((resolve) => setTimeout(resolve, 500 * (attempt + 1)));
      }
    }
    return [];
  }

  async function fetchSuggestedCourses() {
    try {
      const yearsResponse = await axios.get(`${baseURL}/learning/academics`);
      const years = yearsResponse.data?.data || [];

      // Promise.allSettled instead of Promise.all: one failing year
      // no longer wipes out all the others.
      const results = await Promise.allSettled(
        years.map((year) => fetchChapterWithRetry(year.id))
      );

      const allChapters = results
        .filter((r) => r.status === "fulfilled")
        .flatMap((r) => r.value);

      const uniqueChapters = Array.from(new Map(allChapters.map((chapter) => [chapter.id, chapter])).values());
      const visibleChapters = uniqueChapters.filter((chapter) => !chapter.is_draft);
      setCourses(ensureSuggestedCourses(visibleChapters));
    } catch (err) {
      console.error("Error fetching suggested courses for landing page:", err);
      setCourses(ensureSuggestedCourses([]));
    }
  }

  fetchSuggestedCourses();
}, []);


  return (

    <>

      <Header />

      <DynamicAnnouncement />



      {unauthorized && (

        <Alert variant="danger" className="m-3">

          غير مصرح لك بالدخول

        </Alert>

      )}



      {/* 1. Hero - لفت الانتباه فوراً */}

      <HeroSection />



      {/* 2. المراحل الدراسية - "هل ده ليّا؟" */}

      <EducationLevelSection />



      {/* 3. اختيار الصف - تحويل الاهتمام لخطوة فعلية */}

      <section className="grade-selection-section" dir="rtl">

        <div className="container">

          <h2 style={{ fontWeight: 900, fontSize: "1.9rem", color: "#111827", marginBottom: "40px" }} className="text-center">

            اختار السنة الدراسية وادخل علي الكورسات المتاحة لدفعة 2026

          </h2>

          <div className="grade-cards-grid">

            <div className="grade-selection-card" onClick={() => navigate("/courses/grade/1")}>

              <div className="card-title-text">الصف الدراسي الأول</div>

              <div className="card-link-text">← جميع كورسات الصف الأول الثانوي</div>

            </div>

            <div className="grade-selection-card" onClick={() => navigate("/courses/grade/2")}>

              <div className="card-title-text">الصف الدراسي الثاني</div>

              <div className="card-link-text">← جميع كورسات الصف الثاني الثانوي</div>

            </div>

            <div className="grade-selection-card" onClick={() => navigate("/courses/grade/3")}>

              <div className="card-title-text">الصف الدراسي الثالث</div>

              <div className="card-link-text">← جميع كورسات الصف الثالث الثانوي</div>

            </div>

          </div>

        </div>

      </section>



            <style>{`

        .teacher-card:hover {

          transform: translateY(-8px);

          box-shadow: 0 12px 30px rgba(76, 13, 22, 0.08) !important;

          border-color: rgba(76, 13, 22, 0.15) !important;

        }

        .teacher-card:hover .avatar-wrapper {

          transform: scale(1.05);

          border-color: rgba(76, 13, 22, 0.1) !important;

        }

        .teacher-card:hover .avatar-img {

          transform: scale(1.08);

        }

        .teacher-card:hover .teacher-name {

          color: var(--brand-purple) !important;

        }

        .btn-brand-premium:hover {

          transform: scale(1.03);

          background-color: var(--brand-100) !important;

          box-shadow: 0 8px 25px rgba(76, 13, 22, 0.2) !important;

        }

      `}</style>



      <div className="py-12 px-4" dir="rtl" style={{ background: "linear-gradient(180deg, #ffffff 0%, var(--brand-purple-light, #fdf2f3) 100%)" }}>

        <div className="container mx-auto">

          <div className="flex flex-col gap-3 justify-center items-center w-full mb-10">

            <div className="heading font-w-bold vipFont text-4xl sm:text-5xl text-center" style={{ color: "var(--brand-300, #4c0d16)", letterSpacing: "-0.5px" }}>

              اختر <span style={{ color: "var(--brand-300, #4c0d16)" }}>المدرسين</span>

            </div>

            <div className="underline-svg w-[200px] sm:w-[260px] inline-block opacity-90">

              <svg className="w-full h-full" viewBox="0 0 407 49" fill="none" xmlns="http://www.w3.org/2000/svg">

                <path className="path-vert" d="M1 48C30.5 5.5 261 -22.5 406 32.3365" stroke="var(--brand-300, #4c0d16)" strokeWidth="3"></path>

              </svg>

            </div>

          </div>



          <div className="d-flex justify-content-center mb-5">

            <div className="d-flex flex-column flex-sm-row gap-3 p-3 rounded-4 shadow-sm bg-white border align-items-center"

                 style={{ 

                   maxWidth: "600px", 

                   width: "100%", 

                   borderRadius: "16px",

                   boxShadow: "0 4px 20px rgba(0, 0, 0, 0.03)"

                 }}>

              

              {/* select 1 */}

              <div className="w-100">

                <select 

                  value={selectedGrade} 

                  onChange={(e) => setSelectedGrade(e.target.value)}

                  className="form-select border-0 px-3 py-2.5"

                  style={{

                    backgroundColor: "var(--brand-purple-light, #fdf2f3)",

                    borderRadius: "10px",

                    fontWeight: "600",

                    color: "var(--brand-300, #4c0d16)",

                    fontSize: "0.95rem",

                    outline: "none",

                    cursor: "pointer",

                    boxShadow: "none"

                  }}

                >

                  <option value="-">الصف الدراسي: الكل</option>

                  {academicYears.map((ay) => (

                    <option key={ay.id} value={ay.id}>{ay.name}</option>

                  ))}

                </select>

              </div>



              {/* Divider for desktop */}

              <div className="d-none d-sm-block bg-light" style={{ width: "2px", height: "30px" }} />



              {/* select 2 */}

              <div className="w-100">

                <select 

                  value={selectedSubject} 

                  onChange={(e) => setSelectedSubject(e.target.value)}

                  className="form-select border-0 px-3 py-2.5"

                  style={{

                    backgroundColor: "var(--brand-purple-light, #fdf2f3)",

                    borderRadius: "10px",

                    fontWeight: "600",

                    color: "var(--brand-300, #4c0d16)",

                    fontSize: "0.95rem",

                    outline: "none",

                    cursor: "pointer",

                    boxShadow: "none"

                  }}

                >

                  <option value="-">المادة الدراسية: الكل</option>

                  {uniqueSubjects.filter(sub => sub !== "-").map((sub, idx) => (

                    <option key={idx} value={sub}>{sub}</option>

                  ))}

                </select>

              </div>



            </div>

          </div>

        </div>

      </div>



      <section className="pb-16" style={{ backgroundColor: "#ffffff" }}>

        <div className="container-fluid px-3 px-md-5">

          <div className="row g-4 justify-content-center">

            {(showAllTeachers ? filteredTeachers : filteredTeachers.slice(0, 4)).length > 0 ? (

              (showAllTeachers ? filteredTeachers : filteredTeachers.slice(0, 4)).map((teacher) => (

                <div key={teacher.id} className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center mb-4">

                  <a href={`/teacher/${teacher.id}`} className="text-decoration-none">

                    <div className="teacher-card smooth flex-center-both flex-col py-4" 

                         style={{ 

                           backgroundColor: "var(--brand-purple-light, #fdf2f3)", 

                           borderRadius: "16px 0 16px 0", 

                           width: "390px",

                           height: "480px",

                           paddingLeft: "30px",

                           paddingRight: "30px",

                           transition: "all 0.3s ease",

                           border: "none",

                           display: "flex",

                           flexDirection: "column",

                           alignItems: "center",

                           justifyContent: "space-between"

                         }}>

                      

                      {/* Asymmetric leaf-shape image container (330px x 290px) */}

                      <div className="mx-auto overflow-hidden" 

                           style={{ 

                             width: "330px", 

                             height: "290px", 

                             borderRadius: "24px 0 24px 0",

                             backgroundColor: "#cbd5e1"

                           }}>

                        <img 

                          src={teacher.profile_image || (teacher.is_admin_teacher ? LogoNohe : "https://cdn-icons-png.flaticon.com/512/194/194931.png")} 

                          alt={teacher.name}

                          style={{ width: "100%", height: "100%", objectFit: "cover" }}

                        />

                      </div>



                      {/* Details block */}

                      <div className="mt-3 w-100 text-center d-flex flex-column justify-content-center flex-grow-1">

                        <span className="text-center clr-text-primary smooth pt-4 text-xl vipFont font-w-bold d-block text-truncate" 

                              style={{ fontSize: "1.25rem", color: "var(--brand-300, #4c0d16)" }}>

                          {teacher.name}

                        </span>

                        <span className="text-center clr-text-primary smooth text-xl d-block text-truncate" 

                              style={{ fontSize: "1.1rem", color: "#475569" }}>

                          {teacher.subject}

                        </span>

                      </div>

                    </div>

                  </a>

                </div>

              ))

            ) : (

              <div className="text-center py-5 w-100">

                <p className="text-muted">لا يوجد معلمون متوفرون حالياً.</p>

              </div>

            )}

          </div>



          {filteredTeachers.length > 4 && (

            <div className="d-flex justify-content-center mt-5 mb-3">

              {showAllTeachers ? (

                <button 

                  onClick={() => setShowAllTeachers(false)}

                  className="border-2 smooth false text-white rounded-md px-4 py-2" 

                  style={{ 

                    backgroundColor: "var(--brand-300, #4c0d16)", 

                    border: "2px solid var(--brand-300, #4c0d16)",

                    borderRadius: "6px",

                    padding: "8px 24px",

                    fontWeight: "bold",

                    transition: "all 0.2s"

                  }}

                >

                  عرض أقل

                </button>

              ) : (

                <button 

                  onClick={() => setShowAllTeachers(true)}

                  className="border-2 smooth false text-white rounded-md px-4 py-2" 

                  style={{ 

                    backgroundColor: "var(--brand-300, #4c0d16)", 

                    border: "2px solid var(--brand-300, #4c0d16)",

                    borderRadius: "6px",

                    padding: "8px 24px",

                    fontWeight: "bold",

                    transition: "all 0.2s"

                  }}

                >

                  عرض المزيد من المدرسين

                </button>

              )}

            </div>

          )}

        </div>

      </section>



      {/* 6. الكورسات المقترحة - المستخدم مقتنع، دلوقتي يشوف المنتج */}

      <section className="suggested-courses-section" style={{ backgroundColor: "#f8f9fa" }}>

        <div className="container mb-4">

          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3" dir="rtl">

            <h2 style={{ fontWeight: 900, fontSize: "1.55rem", margin: 0, color: "#111827" }}>

              كورساتنا المقترحة للعام 2025/2026

            </h2>

            <div className="filter-pills">

              <button className="btn-filter-pill active">الكل</button>

            </div>

          </div>

        </div>



        <div className="suggested-courses-slider-wrapper">

          {courses.length > 0 ? (

            <Swiper

              dir="rtl"

              modules={[Autoplay, Navigation, Pagination]}

              loop={courses.length >= 4}

              navigation={true}

              pagination={{ clickable: true }}

              autoplay={{ delay: 3000, disableOnInteraction: false }}

              breakpoints={{

                0: { slidesPerView: 1.1, spaceBetween: 12 },

                480: { slidesPerView: 1.4, spaceBetween: 14 },

                768: { slidesPerView: 2.1, spaceBetween: 16 },

                1024: { slidesPerView: 3.05, spaceBetween: 18 },

                1400: { slidesPerView: 3.2, spaceBetween: 18 },

              }}

            >

              {courses.map((course) => {

                const badgeInfo = getCourseBadge(course.name);

                return (

                  <SwiperSlide key={course.id} style={{ height: "auto" }}>

                    <div className="suggested-course-card">

                      <div className="course-image-wrapper">

                        <img src={course.image} alt={course.name} />

                        {badgeInfo && (

                          <span className={`course-image-badge badge-${badgeInfo.type}`}>

                            {badgeInfo.text}

                          </span>

                        )}

                      </div>

                      <div className="course-card-body">

                        <h3 className="course-card-title">{course.name}</h3>

                        {course.teacher_name && (

                          <div className="course-teacher-name mb-2 text-muted" style={{ fontSize: "0.9rem", fontWeight: "600" }}>

                            <FaGraduationCap className="ms-1 text-primary" style={{ color: "var(--primary-color)" }} />

                            المدرس: {course.teacher_name}

                          </div>

                        )}

                        {Number(course.discount) > 0 ? (

                          <div className="course-card-price text-end w-100 mb-2" style={{ direction: "rtl" }}>

                            <div className="text-primary-500 fw-bold text-end mb-1" style={{ color: "var(--brand-300)", fontSize: "1.35rem" }}>

                              {Number(course.price) - Number(course.discount)} جنيه

                            </div>

                            <div className="d-flex flex-row gap-1 justify-content-start align-items-center text-muted small" style={{ fontSize: "0.88rem" }}>

                              <span className="text-gray-600 dark:text-gray-200 smooth opacity-75">بدلاً من</span>

                              <span className="text-decoration-line-through text-danger fw-semibold" style={{ color: "#dc3545", fontWeight: "600" }}>{Number(course.price)} جنيهاً</span>

                            </div>

                          </div>

                        ) : (

                          <div className="course-card-price">{course.price} جنيه</div>

                        )}

                        <div className="course-card-details-row">

                          <div className="course-card-desc-col">

                            <p className="course-card-desc">

                              {course.description}

                              <span onClick={() => handleCourseClick(course)} className="course-card-details-link">

                                {" "}... عرض باقي التفاصيل

                              </span>

                            </p>

                          </div>

                          <div className="course-meta-info-col">

                            <div className="course-meta-item">

                              <FaRegCalendarAlt className="meta-icon" />

                              <span>{course.startDate}</span>

                            </div>

                            <div className="course-meta-item">

                              <FaRegClock className="meta-icon" />

                              <span>{course.startTime || course.startDate}</span>

                            </div>

                          </div>

                        </div>

                        <div className="course-card-buttons">

                          <button onClick={() => handleCourseClick(course)} className="btn-enter-course">

                            الدخول للكورس

                          </button>

                          <button onClick={() => handleSubscribeClick(course)} className="btn-subscribe-course">

                            الإشتراك في الكورس !

                          </button>

                        </div>

                      </div>

                    </div>

                  </SwiperSlide>

                );

              })}

            </Swiper>

          ) : (

            <div className="text-center py-5" style={{ color: "#9ca3af" }}>

              لا توجد كورسات للمنصة حاليا، سيتم إضافتها قريبا.

            </div>

          )}

        </div>

      </section>

      <section className="py-5" style={{ backgroundColor: "#f8fafc" }}>
          <div className="container" dir="rtl">
            <div className="text-center mb-4">
              <h2 style={{ fontWeight: 900, fontSize: "2rem", color: "#111827", marginBottom: 10 }}>باقات الترم والسنة الكاملة</h2>
              <p className="text-muted m-auto" style={{ maxWidth: 680 }}>وفّر وقتك وفلوسك: اشترك في باقة الترم أو السنة وافتح كل الشهور المطلوبة مع مدرسك مرة واحدة بسعر أوفر وتجربة أسهل.</p>
            </div>
            {coursePackages.length === 0 ? (
              <div className="text-center py-5" style={{ color: "#9ca3af" }}>
                لا توجد باقات ترم أو سنة كاملة حاليًا، ويمكن إضافتها من لوحة التحكم.
              </div>
            ) : (
            <Row className="g-4 justify-content-center">
              {coursePackages.map((pkg) => {
                const finalPrice = Math.max(Number(pkg.price) - Number(pkg.discount), 0);
                const packageImage = pkg.image || pkg.image_path;

                const packageLabel = getCoursePackageTypeLabel(pkg);
                const openTarget = `/learn/${pkg.academic_year_id}?teacher_id=${pkg.teacher_id}`;
                return (
                  <Col key={pkg.id} xs={12} lg={6} xl={5} className="d-flex justify-content-center">
                    <Card className="suggested-course-card course-package-home-card w-100 border shadow-sm overflow-hidden" style={{ borderRadius: 8, minHeight: 540 }}>
                      <div
                        className="position-relative overflow-hidden"
                        style={{
                          height: 230,
                          background: packageImage ? `url(${packageImage}) center/cover no-repeat` : "linear-gradient(135deg, #0f766e 0%, #4c0d16 100%)",
                        }}
                      >
                        <span className="position-absolute badge bg-warning text-dark m-3" style={{ top: 0, right: 0 }}>{packageLabel}</span>
                      </div>
                      <Card.Body className="text-end d-flex flex-column p-4">
                        <div className="d-flex gap-2 flex-wrap mb-3 justify-content-end">
                          <span className="badge bg-light text-dark border">{pkg.academic_year_name}</span>
                          <span className="badge bg-light text-dark border">{pkg.teacher_name}</span>
                          <span className="badge bg-light text-dark border">{pkg.chapters_count} شهر</span>
                        </div>
                        <h3 className="fw-bold mb-2" style={{ fontSize: "1.25rem", lineHeight: 1.5 }}>{pkg.name}</h3>
                        <p className="text-muted mb-3" style={{ lineHeight: 1.7, minHeight: 58 }}>{pkg.description || `اشتراك ${packageLabel} يفتح ${pkg.chapters_count} شهر مع ${pkg.teacher_name}.`}</p>
                        <div className="mt-auto">
                          {/* Pricing */}
                          <div className="d-flex justify-content-between align-items-center mb-4" dir="rtl">
                            <div className="text-end">
                              <div className="small text-muted">السعر الموحد:</div>
                              <div className="d-flex align-items-center gap-2">
                                <span className="fs-4 fw-bold text-primary">{finalPrice.toFixed(0)} ج.م</span>
                                {Number(pkg.discount) > 0 && (
                                  <span className="text-decoration-line-through text-muted small">{Number(pkg.price).toFixed(0)} ج.م</span>
                                )}
                              </div>
                            </div>
                            {Number(pkg.discount) > 0 && (
                              <span className="badge bg-danger-light text-danger fs-6 py-2 px-3 rounded-pill">
                                وفر {Number(pkg.discount).toFixed(0)} ج.م
                              </span>
                            )}
                          </div>
                          <div className="course-card-buttons package-card-buttons">
                            <Button className="btn-enter-course" onClick={() => navigate(`/packages/${pkg.id}`)}>التفاصيل</Button>
                            <Button
                              className="btn-subscribe-course"
                              onClick={() => pkg.has_accessed ? navigate(openTarget) : (auth?.accessToken ? navigate(`/invoice/package/${pkg.id}`) : navigate("/register"))}
                            >
                              {pkg.has_accessed ? "الدخول للشهور" : "اشترك الآن"}
                            </Button>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
            )}
          </div>
        </section>

      {/* 6.5. باقات الكورسات المشتركة (الكومبو) - عرض العروض والتوفير للطلاب */}
      {combos.length > 0 && (
        <section className="py-5" style={{ backgroundColor: "#ffffff" }}>
          <div className="container mb-5">
            <div className="text-center" dir="rtl">
              <h2 style={{ fontWeight: 900, fontSize: "2rem", color: "#111827", marginBottom: "15px" }}>
                باقات الكورسات المشتركة (الكومبو) 🎓
              </h2>
              <p className="text-muted fs-6" style={{ maxWidth: "600px", margin: "0 auto" }}>
                وفر واشترك في عدة وحدات دراسية معاً دفعة واحدة وبسعر مخفض، لتفتح لك جميع الدروس والامتحانات فوراً!
              </p>
            </div>
          </div>

          <div className="container">
            <Row className="g-4 justify-content-center" dir="rtl">
              {combos.map((combo) => {
                const totalPrice = Number(combo.price);
                const discountVal = Number(combo.discount);
                const finalPrice = Math.max(totalPrice - discountVal, 0);

                return (
                  <Col key={combo.id} xs={12} lg={6} className="d-flex justify-content-center">
                    <Card 
                      className="suggested-course-card w-100 border shadow-sm rounded-4 overflow-hidden" 
                      style={{ 
                        transition: "all 0.3s ease",
                        border: "1px solid #e5e7eb",
                        display: "flex",
                        maxWidth: "450px",
                        margin: "0 auto",
                        flexDirection: "column"
                      }}
                    >
                      <div 
                        className="position-relative overflow-hidden" 
                        style={{ 
                          height: "180px", 
                          background: (combo.image || combo.image_path) ? `url(${combo.image || combo.image_path}) center/cover no-repeat` : "linear-gradient(135deg, #7c3aed 0%, #4c0d16 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        {!(combo.image || combo.image_path) && (
                          <div className="text-white text-center p-3">
                            <h3 className="fw-bold m-0 text-white" style={{ fontSize: "1.4rem" }}>{combo.name}</h3>
                            <span className="badge bg-warning text-dark mt-2 fs-6">عرض توفير مميز</span>
                          </div>
                        )}
                        {(combo.image || combo.image_path) && (
                          <span 
                            className="position-absolute badge bg-warning text-dark m-3" 
                            style={{ top: 0, right: 0, fontSize: "0.85rem", fontWeight: "bold" }}
                          >
                            باقة التوفير
                          </span>
                        )}
                      </div>

                      <Card.Body className="d-flex flex-column text-end p-4">
                        <h4 className="fw-bold mb-2 text-dark">{combo.name}</h4>
                        <p className="text-muted small mb-3 flex-grow-0 text-truncate-3" style={{ lineHeight: "1.6", minHeight: "60px" }}>
                          {combo.description || "باقة تجمع مجموعة من الوحدات والشهور الدراسية لتمنح الطالب تجربة تعليمية متكاملة بخصم خاص."}
                        </p>

                        <div className="mb-4 bg-light p-3 rounded-3" style={{ flexGrow: 1 }}>
                          <div className="fw-bold text-secondary small mb-2">الوحدات المشمولة بالباقة:</div>
                          <ul className="m-0 p-0" style={{ listStyle: "none", fontSize: "0.85rem" }}>
                            {combo.chapters && combo.chapters.map((ch) => (
                              <li key={ch.id} className="d-flex align-items-center gap-2 mb-2 text-dark">
                                <span className="text-primary font-bold">•</span>
                                <span className="text-truncate">{ch.name} ({ch.teacher_name || "الأدمن"})</span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <div>
                            <div className="small text-muted">السعر الموحد:</div>
                            <div className="d-flex align-items-center gap-2">
                              <span className="fs-4 fw-bold text-primary">{finalPrice.toFixed(0)} ج.م</span>
                              {discountVal > 0 && (
                                <span className="text-decoration-line-through text-muted small">{totalPrice.toFixed(0)} ج.م</span>
                              )}
                            </div>
                          </div>
                          {discountVal > 0 && (
                            <span className="badge bg-danger-light text-danger fs-6 py-2 px-3 rounded-pill">
                              وفر {discountVal.toFixed(0)} ج.م
                            </span>
                          )}
                        </div>

                        <div className="d-flex flex-column gap-2 mt-auto">
                          <Button 
                            onClick={() => navigate(`/combos/${combo.id}`)}
                            variant="outline-primary"
                            className="rounded-pill py-2 fw-bold"
                            style={{
                              borderColor: "var(--brand-300)",
                              color: "var(--brand-300)",
                              backgroundColor: "transparent"
                            }}
                          >
                            تفاصيل الباقة
                          </Button>
                          <Button 
                            onClick={() => {
                              if (!auth?.accessToken) {
                                toast.info("يرجى تسجيل الدخول أو إنشاء حساب للاشتراك");
                                navigate("/register");
                              } else {
                                navigate(`/invoice/combo/${combo.id}`);
                              }
                            }}
                            className="rounded-pill py-2 fw-bold"
                            style={{
                              backgroundColor: "var(--brand-300)",
                              borderColor: "var(--brand-300)",
                              color: "#fff"
                            }}
                          >
                            اشترك الآن!
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </div>
        </section>
      )}

      {/* 7. آراء الطلاب - Social Proof بعد ما شاف المنتج */}
      <section style={{ padding: "60px 0", background: "#f8f9fa" }}>
        <h2 className="text-center fw-bold mb-5 fs-3">ماذا يقول طلابنا؟</h2>
        <div className="testimonials-wrapper" dir="ltr">
          <div className="testimonials-track">
            {[...testimonials, ...testimonials].map((t, i) => (
              <div
                key={i}
                className="bg-third-container clr-text-primary smooth rounded-xl p-4 d-flex flex-column gap-3 testimonial-card"
                style={{ minWidth: "320px", maxWidth: "320px" }}
                dir="rtl"
              >
                <div className="d-flex gap-1" style={{ color: "var(--brand-200-alt, #cca245)", fontSize: "16px" }}>
                  {Array.from({ length: t.stars }).map((_, index) => (
                    <FaStar key={index} />
                  ))}
                </div>
                <p className="small clr-text-secondary" style={{ lineHeight: "1.7" }}>"{t.text}"</p>
                <div className="mt-auto">
                  <div className="font-bold">{t.name}</div>
                  <div className="small clr-text-secondary">{t.level}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 8. CTA - الدعوة للتسجيل بعد الاقتناع الكامل */}
      <section className="py-5 px-3 bg-white">
        <div className="container">
          <div
            className="cta-banner-wrapper d-flex align-items-center justify-content-between p-4 p-md-5 rounded-4 position-relative overflow-hidden"
            dir="rtl"
          >
            <div className="cta-banner-content text-end">
              <h2 className="cta-banner-title fw-bold mb-3">إبدأ رحلة تحقيق حلمك دلوقتي ✨</h2>
              <p className="cta-banner-subtitle mb-4">جرّب أول محاضرة مجاناً وشوف الفرق بنفسك.</p>
              <button
                className="btn-cta-banner-action"
                onClick={() => {
                  if (!auth?.accessToken) {
                    navigate("/register");
                  } else if (auth.user?.is_staff) {
                    navigate("/DashboardLayout");
                  } else if (auth.user?.academic_year_id) {
                    navigate(`/courses/grade/${auth.user.academic_year_id}`);
                  } else {
                    navigate("/courses");
                  }
                }}
              >
                ابدأ رحلتك
              </button>
            </div>
            <div className="cta-banner-image-container d-none d-md-block">
              <img src={LogoNohe} alt="شعار المنصة" className="cta-banner-img" style={{ maxHeight: "180px", objectFit: "contain" }} />
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <SocialMadia />
    </>
  );
}
